<script>
    import { translate, _ } from "../services/i18n";
    import { userStore } from "../services/session";


    export let customText = "";

    let showText = "";

    userStore.subscribe(client => {
        if (!client || !client.getClientName()) {
            showText = "";
            return;
        }
        showText = `${ translate(customText) } '${ $userStore.getClientName() }'`;
    });
</script>

<header>
    <h2>{showText}</h2>
    <p>{$_("header_selectAnotherClientInfoText")}</p>
</header>

<style>
    header {
        text-align: center;
    }
</style>